/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable no-irregular-whitespace */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useAlert } from 'react-alert';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { fetchRecuperarAcesso } from '../../api/endpoints';
import { getTotem } from '../../api/apiFactory';
import { selectCidade } from '../../app/slices/cidadesSlice';
import { desfazerConexao, fetchLogin, fetchLoginAnonimo } from '../../app/slices/loginSlice';
import { fecharModalLogin, selectModal } from '../../app/slices/modalSlice';
import { definirSecretaria } from '../../app/slices/secretariasSlice';
import {
  BreadCumbs,
  Container,
  ContainerJanela, ContainerTotem, Divisor, FormFooter, Linha, Titulo,
} from '../../styles/base';
import {
  cnpj, cpf, email, isCNPJ, isEmail, tel,
} from '../../util/mascaras';
import Botao from '../../components/Botao/Botao';
import { AbaContainer } from '../../components/Botao/BotaoEstilo';
import Carregar from '../../components/Carregar/Carregar';
import FormControl from '../../components/FormControl/FormControl';
import {
  Aviso, JanelaLogin, JanelaLoginTotem, ContainerSeletor, LinkEmail, TituloModal,
} from './TotemLoginEstilo';
import { espacamento } from '../../styles/constants/sizes';

const defaultValues = {
  Usuario: '',
  Senha: '',
  Email: '',
  CpfCnpj: '',
  Telefone: '',
};

const TotemLogin = ({
  ouvidoria, sic, zeladoria, acompanhamento, cadastro,
}) => {
  const [recuperarSenha, setRecuperarSenha] = useState(false);
  const [emailLoginAtivo, setEmailLoginAtivo] = useState(true);
  const [emailRecuperarAtivo, setEmailRecuperarAtivo] = useState(true);
  const [carregando, setCarregando] = useState(false);
  const [values, setValues] = useState(defaultValues);
  const [tipoCampoSenha, setTipoCampoSenha] = useState('senhaTotem');
  const history = useHistory();

  const dispatch = useDispatch();
  const alert = useAlert();
  const dadosCidade = useSelector(selectCidade);

  const setVal = (key, val) => setValues({
    ...values, [key]: val,
  });

  const recuperarAcessoSenhaEmail = async (event) => {
    event.preventDefault();
    setCarregando(true);
    const resposta = await fetchRecuperarAcesso(`e-${values.Email}`);

    if (resposta.Message === 'Nenhum registro foi encontrado.') {
      setCarregando(false);
      return alert.error('Nenhum registro foi encontrado.', { timeout: 5000 });
    }
    if (values.Email !== '') {
      setCarregando(false);
      alert.success('E-mail enviado com sucesso.', { timeout: 5000 });
    } else {
      alert.error('Por favor, preencha o campo "E-mail".', { timeout: 5000 });
      setCarregando(false);
    }
    setCarregando(false);
    return setValues(defaultValues);
  };

  const recuperarAcessoSenhaTelefone = async (event) => {
    event.preventDefault();
    setCarregando(true);
    const resposta = await fetchRecuperarAcesso(`t-${values.Telefone}`);

    if (resposta.Message === 'Nenhum registro foi encontrado.') {
      setCarregando(false);
      return alert.error('Nenhum registro foi encontrado.', { timeout: 5000 });
    }

    if (values.Telefone !== '') {
      setCarregando(false);
      alert.success('SMS enviado com sucesso.', { timeout: 5000 });
    } else {
      alert.error('Por favor, preencha o campo "Telefone".', { timeout: 5000 });
      setCarregando(false);
    }
    setCarregando(false);
    return setValues(defaultValues);
  };

  const entrarCadastrado = async (event) => {
    event.preventDefault();
    setCarregando(true);
    const resposta = await dispatch(fetchLogin({
      username: values.Usuario,
      password: values.Senha,
    }));

    if (!values.Usuario) {
      dispatch(desfazerConexao());
      setCarregando(false);
      return alert.error('Acesso negado, por favor tente novamente.', { timeout: 5000 });
    }

    if (emailLoginAtivo && !values.Usuario.includes('@')) {
      dispatch(desfazerConexao());
      setCarregando(false);
      return alert.error('Acesso negado, por favor tente novamente.', { timeout: 5000 });
    }

    if (resposta.payload === 'Credencial errada.') {
      dispatch(desfazerConexao());
      setCarregando(false);
      return alert.error('Acesso negado, por favor tente novamente.', { timeout: 5000 });
    }

    setCarregando(false);

    if (cadastro && ouvidoria) {
      history.push('/totem/ouvidoria/cadastrar');
    }
    if (cadastro && sic) {
      history.push('/totem/sic/cadastrar');
    }
    if (cadastro && zeladoria) {
      history.push('/totem/zeladoria/cadastrar');
    }

    if (acompanhamento && ouvidoria) {
      history.push('/totem/ouvidoria/acompanhamento');
    }
    if (acompanhamento && sic) {
      history.push('/totem/sic/acompanhamento');
    }
    if (acompanhamento && zeladoria) {
      history.push('/totem/zeladoria/acompanhamento');
    }

    return true;
  };

  const handleVoltar = () => {
    if (ouvidoria && acompanhamento) {
      if ((dadosCidade && dadosCidade.configuracoes && dadosCidade.configuracoes.OcultarAnonimoOuvidoria === 'N') || (dadosCidade && dadosCidade.configuracoes && dadosCidade.configuracoes.OcultarAnonimoSic === 'N') || (dadosCidade && dadosCidade.configuracoes && dadosCidade.configuracoes.OcultarAnonimoZeladoria === 'N') || (dadosCidade && dadosCidade.configuracoes && dadosCidade.configuracoes.AcompanhamentoAnonimo === 'N')) {
        history.push('/totem/ouvidoria');
      } else {
        history.push('/totem/ouvidoria/acompanhamento/escolhalogin');
      }
    }
    if (ouvidoria && cadastro) {
      history.push('/totem/ouvidoria/cadastrar/escolhalogin');
    }

    if (sic && acompanhamento) {
      if ((dadosCidade && dadosCidade.configuracoes && dadosCidade.configuracoes.OcultarAnonimoOuvidoria === 'N') || (dadosCidade && dadosCidade.configuracoes && dadosCidade.configuracoes.OcultarAnonimoSic === 'N') || (dadosCidade && dadosCidade.configuracoes && dadosCidade.configuracoes.OcultarAnonimoZeladoria === 'N') || (dadosCidade && dadosCidade.configuracoes && dadosCidade.configuracoes.AcompanhamentoAnonimo === 'N')) {
        history.push('/totem/sic');
      } else {
        history.push('/totem/sic/acompanhamento/escolhalogin');
      }
    }
    if (sic && cadastro) {
      history.push('/totem/sic/cadastrar/escolhalogin');
    }

    if (zeladoria && acompanhamento) {
      if ((dadosCidade && dadosCidade.configuracoes && dadosCidade.configuracoes.OcultarAnonimoOuvidoria === 'N') || (dadosCidade && dadosCidade.configuracoes && dadosCidade.configuracoes.OcultarAnonimoSic === 'N') || (dadosCidade && dadosCidade.configuracoes && dadosCidade.configuracoes.OcultarAnonimoZeladoria === 'N') || (dadosCidade && dadosCidade.configuracoes && dadosCidade.configuracoes.AcompanhamentoAnonimo === 'N')) {
        history.push('/totem/zeladoria');
      } else {
        history.push('/totem/zeladoria/acompanhamento/escolhalogin');
      }
    }
    if (zeladoria && cadastro) {
      history.push('/totem/zeladoria/cadastrar/escolhalogin');
    }
  };

  const manipularTipoCampoSenha = () => {
    if (tipoCampoSenha === 'senhaTotem') {
      setTipoCampoSenha('inputLoginTotemVisualizacao');
    } else {
      setTipoCampoSenha('senhaTotem');
    }
  };

  if (recuperarSenha) {
    return (
      <>
        <BreadCumbs>
          Você está em:
          {' '}
          {(ouvidoria) && (<span style={{ fontWeight: 'bold' }}>Ouvidoria</span>)}
          {(sic) && (<span style={{ fontWeight: 'bold' }}>Pedido de Informação (e-SIC)</span>)}
          {(zeladoria) && (<span style={{ fontWeight: 'bold' }}>Zeladoria</span>)}
          {' '}
          &rsaquo;
          {' '}
          <span style={{ fontWeight: 'bold' }}>Recuperar Acesso</span>
        </BreadCumbs>
        <ContainerTotem style={{ alignItems: 'flex-start', marginTop: 180 }}>
          <Container totemLogin>
            <Botao
              voltar
              label="Voltar"
              style={{
                marginRight: espacamento.pequeno, fontSize: 25, flex: 'unset',
              }}
              onClick={() => setRecuperarSenha(false)}
            />
            <form>
              <ContainerSeletor>
                <input type="radio" id="email" name="seletor" defaultChecked onClick={() => setEmailRecuperarAtivo(true)} />
                <label
                  htmlFor="email"
                >
                  E-mail
                </label>
              </ContainerSeletor>

              <ContainerSeletor>
                <input type="radio" id="telefone" name="seletor" onClick={() => setEmailRecuperarAtivo(false)} />
                <label
                  htmlFor="telefone"
                >
                  Telefone
                </label>
              </ContainerSeletor>

              {emailRecuperarAtivo ? (
                <FormControl
                  idCampo="inputEmail"
                  value={values.Email && email(values.Email)}
                  label=""
                  onChange={({ target }) => setVal('Email', target.value)}
                  type="inputLoginTotemEmail"
                />
              ) : (
                <FormControl
                  idCampo="inputTelefone"
                  value={values.Telefone && tel(values.Telefone)}
                  label=""
                  onChange={({ target }) => setVal('Telefone', target.value)}
                  type="inputLoginTotemEmail"
                />
              )}

              <FormFooter style={{ justifyContent: 'space-between' }}>
                {carregando !== true
                  ? (
                    <Botao
                      label="Enviar"
                      type="submitTotem"
                      onClick={emailRecuperarAtivo ? recuperarAcessoSenhaEmail : recuperarAcessoSenhaTelefone}
                      style={{
                        marginTop: 20, padding: '20px 80px', fontSize: 20,
                      }}
                    />
                  )
                  : (
                    <Carregar
                      login
                      style={{
                        marginTop: 20, padding: '20px 80px', fontSize: 20,
                      }}
                    />
                  )}
                <Botao
                  label="Voltar"
                  type="submitTotem"
                  onClick={() => setRecuperarSenha(!recuperarSenha)}
                  style={{
                    marginTop: 20, padding: '20px 70px', fontSize: 20, background: '#a1a1a1',
                  }}
                />
              </FormFooter>

            </form>

            <Divisor />
          </Container>
        </ContainerTotem>
      </>
    );
  }

  return (
    <>
      <BreadCumbs>
        Você está em:
        {' '}
        {(ouvidoria) && (<span style={{ fontWeight: 'bold' }}>Ouvidoria</span>)}
        {(sic) && (<span style={{ fontWeight: 'bold' }}>Pedido de Informação (e-SIC)</span>)}
        {(zeladoria) && (<span style={{ fontWeight: 'bold' }}>Zeladoria</span>)}
        {' '}
        &rsaquo;
        {' '}
        <span style={{ fontWeight: 'bold' }}>Entrar com meu usuário e senha</span>
      </BreadCumbs>
      <ContainerTotem style={{ alignItems: 'flex-start', marginTop: 180 }}>
        <Container totemLogin>
          <Botao
            voltar
            label="Voltar"
            style={{
              marginRight: espacamento.pequeno, fontSize: 25, flex: 'unset',
            }}
            onClick={() => handleVoltar()}
          />

          <form>
            <ContainerSeletor>
              <input type="radio" id="email" name="seletor" defaultChecked onClick={() => setEmailLoginAtivo(true)} />
              <label
                htmlFor="email"
              >
                E-mail
              </label>
            </ContainerSeletor>

            {dadosCidade && dadosCidade.data && dadosCidade.data.idCidade !== '1183' && (
              <ContainerSeletor>
                <input type="radio" id="cpfcnpj" name="seletor" onClick={() => setEmailLoginAtivo(false)} />
                <label
                  htmlFor="cpfcnpj"
                >
                  CPF ou CNPJ
                </label>
              </ContainerSeletor>
            )}

            {emailLoginAtivo ? (
              <FormControl
                idCampo="inputUsuarioEmail"
                value={values.Usuario}
                onChange={({ target }) => setVal('Usuario', target.value)}
                type="inputLoginTotemEmail"
              />
            ) : (
              <>
                {values.Usuario && isCNPJ(values.Usuario)
                  ? (
                    <FormControl
                      idCampo="inputCNPJ"
                      value={values.Usuario && cnpj(values.Usuario)}
                      label=""
                      onChange={({ target }) => setVal('Usuario', target.value)}
                      type="inputLoginTotemEmail"
                    />
                  ) : (
                    <FormControl
                      idCampo="inputCPF"
                      value={values.Usuario && cpf(values.Usuario)}
                      label=""
                      onChange={({ target }) => setVal('Usuario', target.value)}
                      type="inputLoginTotemEmail"
                    />
                  )}
              </>
            )}

            <div style={{ position: 'relative' }}>
              <FormControl
                idCampo="inputSenha"
                label="Senha"
                value={values.Senha}
                type={tipoCampoSenha}
                onChange={({ target }) => setVal('Senha', target.value)}
              />

              <FormControl
                value={tipoCampoSenha}
                type="exibirSenha"
                altura="7"
                onClick={() => { manipularTipoCampoSenha(); }}
              />
            </div>

            <Divisor size="medio" />

            <FormFooter style={{ justifyContent: 'space-between' }}>
              {carregando !== true
                ? (
                  <Botao
                    label="Entrar"
                    type="submitTotem"
                    onClick={entrarCadastrado}
                    style={{ padding: '10px 60px', fontSize: 22 }}
                  />
                )
                : (
                  <Carregar
                    login
                  />
                )}
              <Botao
                label="Esqueci minha senha"
                link
                onClick={() => {
                  setRecuperarSenha(true);
                }}
                style={{ padding: '10px 0px', fontSize: 22 }}
              />
            </FormFooter>
          </form>

          <Divisor />

        </Container>
      </ContainerTotem>
    </>
  );
};

TotemLogin.propTypes = {
  ouvidoria: PropTypes.bool,
  sic: PropTypes.bool,
  zeladoria: PropTypes.bool,
  acompanhamento: PropTypes.bool,
  cadastro: PropTypes.bool,
};

TotemLogin.defaultProps = {
  ouvidoria: false,
  sic: false,
  zeladoria: false,
  acompanhamento: false,
  cadastro: false,
};

export default TotemLogin;
